import { GateXnorIcon } from './GateXnorIcon';

/**
 * author: Nick
 * id DA573FDA-7BEE-4B80-90BA-AA04932B43C6
 * name gate-xnor
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-xnor.svg
 * tags
 */
export const LogicGateXnorIcon = GateXnorIcon;
export default LogicGateXnorIcon